import { render, staticRenderFns } from "./ListadoTicketsMMCall.vue?vue&type=template&id=12a44243&"
import script from "./ListadoTicketsMMCall.vue?vue&type=script&lang=js&"
export * from "./ListadoTicketsMMCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports